import { createVuetify } from 'vuetify';
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';
import '@mdi/font/css/materialdesignicons.css';

export default createVuetify({
  ssr: false,
  theme: {
    themes: {
      light: {
        colors: {
          background: '#FFFFFF',
          surface: '#FFFFFF',
          'on-surface': '#003366',
          primary: '#6200EE',
          'primary-darken-1': '#3700B3',
          secondary: '#03DAC6',
          'secondary-darken-1': '#018786',
          error: '#a12424',
          info: '#2196F3',
          success: '#99CC00',
          'on-success': '#FFFFFF',
          warning: '#FB8C00'
        }
      }
    }
  },
  components,
  directives
});
